import { toast } from "react-toastify";
import { privateAxios } from "../../../config/apiConfig";
import { CANCELED_ORDER_FAILURE, CANCELED_ORDER_REQUEST, DELIVERED_ORDER_FAILURE, DELIVERED_ORDER_REQUEST, GET_ORDERS_FAILURE, GET_ORDERS_REQUEST, GET_ORDERS_SUCCESS, GET_RECENT_ORDERS_FAILURE, GET_RECENT_ORDERS_REQUEST, GET_RECENT_ORDERS_SUCCESS, PLACED_ORDER_FAILURE, PLACED_ORDER_REQUEST, SHIP_ORDER_FAILURE, SHIP_ORDER_REQUEST, GET_INCOME_FAILURE, GET_INCOME_REQUEST, GET_INCOME_SUCCESS, GET_ORDER_STATS_FAILURE, GET_ORDER_STATS_REQUEST, GET_ORDER_STATS_SUCCESS, GET_DOWNLOAD_ORDER_INVOICE_REQUEST, GET_DOWNLOAD_ORDER_INVOICE_FAILURE } from "./ActionType";


export const getOrders = () => async (dispatch) => {
    dispatch({ type: GET_ORDERS_REQUEST })
    try {
        const { data } = await privateAxios.get(`vendor/orders`);
        dispatch({ type: GET_ORDERS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_ORDERS_FAILURE, payload: error.message })
    }
}

export const getIncome = () => async (dispatch) => {
    dispatch({ type: GET_INCOME_REQUEST })
    try {
        const { data } = await privateAxios.get(`vendor/income-overview`);
        dispatch({ type: GET_INCOME_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_INCOME_FAILURE, payload: error.message })
    }
}

export const getOrderStats = () => async (dispatch) => {
    dispatch({ type: GET_ORDER_STATS_REQUEST })
    try {
        const { data } = await privateAxios.get(`vendor/orders/stats`);
        dispatch({ type: GET_ORDER_STATS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_ORDER_STATS_FAILURE, payload: error.message })
    }
}

export const getDownloadOrderInvoice = (orderId, uniqueOrderId) => async (dispatch) => {
    dispatch({ type: GET_DOWNLOAD_ORDER_INVOICE_REQUEST })
    try {
        const response = await privateAxios.get(`vendor/order/${orderId}/invoice`, { responseType: "blob" });
        if (response?.status === 200) {
            const url = window.URL.createObjectURL(
                new Blob([response.data])
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `ORDER_${uniqueOrderId}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            dispatch(getOrders())
            toast.success("Invoive Downloaded Successfully")
        }
    } catch (error) {
        dispatch({ type: GET_DOWNLOAD_ORDER_INVOICE_FAILURE, payload: error.message })
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
    }
}

export const getRecentOrders = () => async (dispatch) => {
    dispatch({ type: GET_RECENT_ORDERS_REQUEST })
    try {
        const { data } = await privateAxios.get(`vendor/recent_orders`);
        dispatch({ type: GET_RECENT_ORDERS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_RECENT_ORDERS_FAILURE, payload: error.message })
    }
}

export const shipOrder = (orderId) => async (dispatch) => {
    dispatch({ type: SHIP_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`vendor/order/${orderId}/ship`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Shipped Successfully")
        } else {
            toast.error(data.response)
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: SHIP_ORDER_FAILURE, payload: error.message })
    }
}

export const deliveredOrder = (orderId) => async (dispatch) => {
    dispatch({ type: DELIVERED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`vendor/order/${orderId}/deliver`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Delivered Successfully")
        } else {
            toast.error(data.response)
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: DELIVERED_ORDER_FAILURE, payload: error.message })
    }
}

export const cancelOrder = (orderId) => async (dispatch) => {
    dispatch({ type: CANCELED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`vendor/order/${orderId}/cancel`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Canceled Successfully")
        } else {
            toast.error(data.response)
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: CANCELED_ORDER_FAILURE, payload: error.message })
    }
}

export const placeOrder = (orderId) => async (dispatch) => {
    dispatch({ type: PLACED_ORDER_REQUEST })
    try {
        const { data } = await privateAxios.put(`vendor/order/${orderId}/place`);
        if (data.status === "SUCCESS") {
            dispatch(getOrders())
            toast.success("Order Confirmed Successfully")
        } else {
            toast.error(data.response)
        }

    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response)
        }
        dispatch({ type: PLACED_ORDER_FAILURE, payload: error.message })
    }
}